import React, { useContext } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

import './FaucetHubHeader.scss';

export interface IFaucetHubHeaderProps {
}

export interface IFaucetHubHeaderState {
}

export class FaucetHubHeader extends React.PureComponent<IFaucetHubHeaderProps, IFaucetHubHeaderState> {

  constructor(props: IFaucetHubHeaderProps, state: IFaucetHubHeaderState) {
    super(props);

    this.state = {
		};
  }

	public render(): React.ReactElement<IFaucetHubHeaderProps> {
    return (
      <div className='faucethub-header faucet-bootstrap'>
        <Navbar collapseOnSelect expand="lg" fixed="top" >
          <Container className="navbar-expand">
            <Navbar.Brand href="https://faucets.pk910.de">PoWFaucet</Navbar.Brand>
            <Nav className="me-auto flex-row">
              <NavDropdown title={
                <span>
                  Hoodi
                </span>
                } id="hoodi-faucet" autoClose>
                <NavDropdown.Item href="https://hoodi-faucet.pk910.de">PoW Faucet</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="https://github.com/eth-clients/hoodi" target="_blank">
                  Testnet Details
                </NavDropdown.Item>
                <NavDropdown.Item href="https://faucetlink.to/hoodi" target="_blank">
                  Other Faucets
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title={
                <span>
                  Sepolia
                </span>
                } id="sepolia-faucet" autoClose>
                <NavDropdown.Item href="https://sepolia-faucet.pk910.de">PoW Faucet</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="https://github.com/eth-clients/sepolia" target="_blank">
                  Testnet Details
                </NavDropdown.Item>
                <NavDropdown.Item href="https://faucetlink.to/sepolia" target="_blank">
                  Other Faucets
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title={
                <span>
                  Ephemery
                </span>
                } id="ephemery-faucet" autoClose>
                <NavDropdown.Item href="https://ephemery-faucet.pk910.de">PoW Faucet</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="https://github.com/ephemery-testnet/ephemery-resources" target="_blank">
                  Testnet Details
                </NavDropdown.Item>
              </NavDropdown>
              {/* Devcon 8 drop (Mumbai, 3-6 Nov 2026): enable once the Devcon app lists the faucet perk
              <NavDropdown title={
                <span>
                  Devcon 8
                </span>
                } id="devcon8-faucet" className="ms-2" autoClose>
                <NavDropdown.Item href="https://devcon-sepolia-faucet.pk910.de/">Sepolia Drop (100 SepETH)</NavDropdown.Item>
                <NavDropdown.Item href="https://devcon-hoodi-faucet.pk910.de/">Hoodi Drop (500 HodETH)</NavDropdown.Item>
              </NavDropdown>
              */}
            </Nav>
          </Container>
        </Navbar>
      </div>
    );
	}

}

/*
  <Nav>
    <Nav.Link href="https://faucets.pk910.de/#/stats">Stats</Nav.Link>
  </Nav>

  <NavDropdown.Divider />
  <NavDropdown.Item href="#action/3.4">
    Separated link
  </NavDropdown.Item>
*/

export default (props) => {
  return (
    <FaucetHubHeader 
      {...props}
    />
  );
};
